import React from 'react';
import './QuizReview.css';

const QuizReview = ({ results, quizType, onBackToScore }) => {
  // Get the question display text based on quiz type
  const getQuestionDisplay = (result) => {
    const { question } = result;
    
    switch (quizType) {
      case 'build-description':
        return {
          type: 'Ingredients',
          content: question.description.split(/[,;]/).map(part => part.trim()).join(', '),
          answer: question.name
        };
      case 'culinary-terms':
        return {
          type: 'Term',
          content: question.term,
          answer: question.definition
        };
      default:
        // Description matching - randomly show either name or description as question
        const showName = Math.random() < 0.5;
        return {
          type: showName ? 'Name' : 'Description',
          content: showName ? question.name : question.description,
          answer: showName ? question.description : question.name
        };
    }
  };

  // Generate Google search URL for a question
  const getSearchUrl = (question) => {
    let searchTerm = '';
    
    switch (quizType) {
      case 'culinary-terms':
        searchTerm = `${question.term} culinary definition`;
        break;
      default:
        searchTerm = `Red Tavern ${question.name}`;
        break;
    }
    
    return `https://google.com/search?q=${encodeURIComponent(searchTerm)}`;
  };

  // Calculate statistics
  const correctAnswers = results.filter(r => r.isCorrect).length;
  const incorrectAnswers = results.length - correctAnswers;
  const percentage = Math.round((correctAnswers / results.length) * 100);

  return (
    <div className="quiz-review">
      <div className="review-header">
        <div className="review-stats">
          <div className="stat correct">
            <span className="stat-number">{correctAnswers}</span>
            <span className="stat-label">Correct</span>
          </div>
          <div className="stat incorrect">
            <span className="stat-number">{incorrectAnswers}</span>
            <span className="stat-label">Incorrect</span>
          </div>
          <div className="stat percentage">
            <span className="stat-number">{percentage}%</span>
            <span className="stat-label">Score</span>
          </div>
        </div>
        
        <button className="back-to-score-button" onClick={onBackToScore}>
          ← Back to Score
        </button>
      </div>

      <div className="review-questions">
        <h3>Question Review</h3>
        
        {results.map((result, index) => {
          const questionDisplay = getQuestionDisplay(result);
          
          return (
            <div 
              key={index} 
              className={`review-item ${result.isCorrect ? 'correct' : 'incorrect'}`}
            >
              <div className="review-item-header">
                <span className="question-number">#{index + 1}</span>
                <span className={`result-badge ${result.isCorrect ? 'correct' : 'incorrect'}`}>
                  {result.isCorrect ? '✓ Correct' : '✗ Incorrect'}
                </span>
              </div>
              
              <div className="review-content">
                <div className="question-section">
                  <strong>{questionDisplay.type}:</strong>
                  <div className="question-text">{questionDisplay.content}</div>
                  {result.question.category && (
                    <small className="category-hint">Category: {result.question.category}</small>
                  )}
                </div>
                
                <div className="answer-section">
                  <div className="correct-answer">
                    <strong>Correct Answer:</strong>
                    <div className="answer-text correct">{result.correctAnswer}</div>
                  </div>
                  
                  {!result.isCorrect && (
                    <div className="user-answer">
                      <strong>Your Answer:</strong>
                      <div className="answer-text incorrect">{result.userAnswer}</div>
                    </div>
                  )}
                </div>
                
                <div className="lookup-section">
                  <a 
                    href={getSearchUrl(result.question)} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="lookup-button"
                  >
                    🔍 Look Up
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="review-footer">
        <button className="back-to-score-button" onClick={onBackToScore}>
          ← Back to Score
        </button>
      </div>
    </div>
  );
};

export default QuizReview; 